export const useLiveChat = (lang) => {
    // eslint-disable-next-line no-underscore-dangle
    if (window.__lc) {
        const liveChat = document.getElementById('chat-widget-container');
        if (liveChat) {
            liveChat.classList.remove('display-none');
        }
        return;
    }

    // eslint-disable-next-line no-underscore-dangle
    const __lc = {};
    __lc.license = 1067033;
    if (lang === 'es' || lang === 'spanish') {
        __lc.skill = 58;
    } else if (lang === 'chinese') {
        __lc.skill = 62;
    } else if (lang === 'chineset') {
        __lc.skill = 59;
    } else if (lang === 'it' || lang === 'italian') {
        __lc.skill = 56;
    } else if (lang === 'pt' || lang === 'portuguese' || lang === 'br' || lang === 'brazil') {
        __lc.skill = 54;
    } else if (lang === 'de' || lang === 'german') {
        __lc.skill = 55;
    } else if (lang === 'indian') {
        __lc.skill = 60;
    } else if (lang === 'jp' || lang === 'japanese') {
        __lc.skill = 57;
    } else if (lang === 'fr' || lang === 'french') {
        __lc.skill = 63;
    } else {
        __lc.skill = 61;
    }

    // eslint-disable-next-line no-underscore-dangle
    window.__lc = __lc;
    const lc = document.createElement('script');
    lc.type = 'text/javascript';
    lc.async = true;
    lc.id = 'livechat-script';
    lc.src = `${
        document.location.protocol === 'https:' ? 'https://' : 'http://'
    }cdn.livechatinc.com/tracking.js`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(lc, s);
};

export const destroyLiveChat = () => {
    const liveChat = document.getElementById('chat-widget-container');
    if (liveChat) {
        liveChat.classList.add('display-none');
    }
};



// WEBPACK FOOTER //
// ./app/utils/livechat.js